// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3QNE0","content":"_2qcai"};